import { Report } from "../enums/Report";

export const hours = [
    {label: "01:00", val: 1 },
    {label: "02:00", val: 2 },
    {label: "03:00", val: 3 },
    {label: "04:00", val: 4 },
    {label: "05:00", val: 5 },
    {label: "06:00", val: 6 },
    {label: "07:00", val: 7 },
    {label: "08:00", val: 8 },
    {label: "09:00", val: 9 },
    {label: "10:00", val: 10 },
    {label: "11:00", val: 11 },
    {label: "12:00", val: 12 },
    {label: "13:00", val: 13 },
    {label: "14:00", val: 14 },
    {label: "15:00", val: 15 },
    {label: "16:00", val: 16 },
    {label: "17:00", val: 17 },
    {label: "18:00", val: 18 },
    {label: "19:00", val: 19 },
    {label: "20:00", val: 20 },
    {label: "21:00", val: 21 },
    {label: "22:00", val: 22 },
    {label: "23:00", val: 23 },
    {label: "24:00", val: 24 },
]


export const abecedary = [ "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z" ];

export const supportedFiles: any = {
    PDF: ["PDF", "JP2"], 
    IMAGE: ["JPG", "JPEG", "PNG", "GIF", ".BMP"]
};


export const tiposReporte = [
    {name: "EXCEL"},
    {name: "HTML"},
    {name: "PDF"},
]

export const reportes: { label: string, value: number, route?: string, exclude?: string[] }[] = [
    {label: "Archivos", value: 1, route: Report.FILE}, 
    {label: "Usuarios", value: 2, route: Report.USER},
    {label: "Sentencias publicadas/No publicadas", value: 3, route: "files/public", exclude: ["PDF"]},
];